const objSwal = {
  question: {
    title: '',
    text: '',
    type: 'question',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    cancelButtonText: 'Não',
    confirmButtonText: 'Sim',
    reverseButtons: true
  },
  warning: {
    title: '',
    text: '',
    type: 'warning',
    confirmButtonText: 'Fechar'
  },
  success: {
    title: '',
    text: '',
    type: 'success',
    confirmButtonText: 'Fechar'
  },
  error: {
    title: '',
    text: '',
    type: 'error',
    confirmButtonText: 'Fechar'
  },
  info: {
    title: '',
    text: '',
    type: 'info',
    confirmButtonText: 'Fechar'
  },
  loading: {
    title: ''
  }
}

export default objSwal
